import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    container: {
        padding: "0.5rem 1rem 0rem",
        display: "flex",
        flexDirection: "column",
        gap: "0.75rem",
        overflowWrap: "anywhere",
    },
    item: {
        color: theme.colors.gray[6],
        fontWeight: 400,
    },
    snippet: {
        color: theme.colors.gray[9],
        fontWeight: 500,
    },
    text: {
        color: theme.colors.gray[9],
        fontWeight: 500,
    },
}))
